import { Box } from "@mui/material";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Input from "components/common/Input";
import Typography from "components/common/Typography";
import { uniq } from "lodash";
import { useContext, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getLoggedInUserHltId } from "utils/CommonFunctions";
import { feedbackTypes, responseTypes } from "utils/Types";
import GiveFeedback, { ChildComponentHandles } from "../Feedback/GiveFeedback";
import { fetchAssigneeDetailsAsync, fetchMyPlanDetailAsync } from "../MyPlanDetails/MyPlanDetails.slice";
import { deleteMyPlansAsync } from "./myplans.slice";

interface Props {
  openDeleteCapthaDialog: any;
  setOpenDeleteCapthaDialog: any;
  plan: any;
  source?: any;
  handleInviteDialog?: any;
}

function Delete(props: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const childRef = useRef<ChildComponentHandles>(null);

  const dispatch: any = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const captchaWord = "DELETE";

  const { source, openDeleteCapthaDialog, setOpenDeleteCapthaDialog, plan, handleInviteDialog } = props;
  const [captchaInput, setCaptchaInput] = useState<string>("");

  const handleCloseDeleteDialog = () => {
    setOpenDeleteCapthaDialog(false);
  };

  const planDeleteAction = async () => {
    childRef.current?.submitUserFeedback();
    const response = await dispatch(deleteMyPlansAsync({ id: plan?.id, source }));
    if (response.payload.status < responseTypes.success_threshold && source === "myplandetails") navigate(-1);
  };

  const handlePlanMembers = async () => {
    handleCloseDeleteDialog();
    if (location.pathname.split("/")[1] === "myplans") {
      const response = await dispatch(fetchMyPlanDetailAsync({ id: plan?.id }));
      const membersList = uniq([...(response?.payload?.owners || []), ...(response?.payload?.members || [])]);
      const data = {
        value: membersList,
        size: membersList?.length
      };
      await dispatch(fetchAssigneeDetailsAsync(data));
    }
    handleInviteDialog();
  };

  return (
    <>
      {openDeleteCapthaDialog && (
        <DialogFormation
          title="Are you sure you want to delete this Plan?"
          openDialog={openDeleteCapthaDialog}
          handleClose={handleCloseDeleteDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button
                variant="secondary"
                label="Cancel"
                onClick={handleCloseDeleteDialog}
                width={isMobileScreen ? "50%" : "25%"}
              />
              <Button
                variant="alert"
                label="Delete"
                disabled={captchaInput !== captchaWord}
                onClick={planDeleteAction}
                width={isMobileScreen ? "50%" : "25%"}
              />
            </div>
          }
        >
          <Box
            width="100%"
            alignItems={"flex-start"}
            justifyContent="flex-start"
            textAlign={"center"}
            display={"flex"}
            flexDirection="column"
            gap={"24px"}
          >
            <div style={{ marginBottom: "8px" }}>
              {" "}
              <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody} textAlign={"left"}>
                "{plan.title ?? plan.name}"
              </Typography>
              <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody} textAlign={"left"}>
                Enter the word{" "}
                <Typography component={"span"} showBold>
                  "DELETE"
                </Typography>{" "}
                in input below.
              </Typography>
            </div>
            <div>
              <Typography color={tokens.Text.General.PrimaryBody} variant={"body2"} textAlign={"left"}>
                If you want to remove yourself from this plan without deleting it, go to{" "}
                <Typography
                  variant={"body2"}
                  component={"span"}
                  color={tokens.Text.General.Color}
                  className="cursor-pointer"
                  onClick={handlePlanMembers}
                >
                  <u> Manage Plan Members.</u>
                </Typography>
              </Typography>
            </div>

            <Input
              handleChangeUpdate={(val) => {
                setCaptchaInput(val);
              }}
              name="Title"
              placeholder="Enter the word DELETE in all caps."
              textVariant="body2"
              label={""}
            />
          </Box>
          <Box sx={{ marginTop: "24px" }}>
            <GiveFeedback
              ref={childRef}
              saveFormDataToRedux
              id={process.env.REACT_APP_FEEDBACK_TYPES_DELETE_PLAN}
              type={feedbackTypes.DeletePlan}
              payloadData={{
                myPlanId: plan.id,
                cmsPlanId: plan.cmsId || plan.cmsPlanId,
                planTitle: plan.title || plan.name,
                innCode: plan.innCode,
                planMemberType: plan?.owners?.includes(getLoggedInUserHltId) ? "Owner" : "Member",
                templatePlanId: plan.templatePlanId,
                planSource: plan.planSource
              }}
            />
          </Box>
        </DialogFormation>
      )}
    </>
  );
}

export default Delete;
